import { cn } from '../../../lib/utils'
import { ElementType } from 'react'
import { TrendingUp, TrendingDown, ChevronRight } from 'lucide-react'
import { Link } from 'react-router-dom'

interface GlassMetricCardProps {
  label: string
  value: string
  delta?: string
  deltaPositive?: boolean
  icon?: ElementType
  iconColor?: string
  className?: string
  /** Optional navigation target — makes the whole card a clickable link */
  href?: string
}

export function GlassMetricCard({
  label,
  value,
  delta,
  deltaPositive = true,
  icon: Icon,
  iconColor = 'text-sky-400',
  className,
  href,
}: GlassMetricCardProps) {
  const isPositive = delta ? (delta.startsWith('+') ? true : delta.startsWith('-') ? false : deltaPositive) : deltaPositive

  const inner = (
    <div className={cn(
      'backdrop-blur-xl bg-white/[0.06] border border-white/10 rounded-2xl p-6 flex flex-col gap-3',
      href && 'hover:bg-white/[0.09] hover:border-white/20 transition-all cursor-pointer group',
      className
    )}>
      <div className="flex items-center justify-between">
        <span className="text-sm font-medium text-white/60">{label}</span>
        <div className="flex items-center gap-1">
          {Icon && (
            <span className={cn(
              'w-9 h-9 flex items-center justify-center rounded-xl bg-white/[0.08]',
              iconColor
            )}>
              <Icon size={18} />
            </span>
          )}
          {href && <ChevronRight size={14} className="text-white/20 group-hover:text-white/50 transition-colors" />}
        </div>
      </div>
      <div className="text-2xl font-bold text-white font-display">{value}</div>
      {delta && (
        <div className={cn(
          'flex items-center gap-1 text-xs font-medium',
          isPositive ? 'text-emerald-400' : 'text-red-400'
        )}>
          {isPositive
            ? <TrendingUp className="w-3.5 h-3.5" />
            : <TrendingDown className="w-3.5 h-3.5" />}
          {delta}
        </div>
      )}
    </div>
  )

  return href ? <Link to={href} className="block">{inner}</Link> : inner
}
